import ListingVM from './listing-vm';
export default {
  init: function(node){
    var groups_data = JSON.parse($('#groups_json').val());
    var coursework_listing = JSON.parse($('#coursework_listing_json').val());
    ko.applyBindingsWithValidation(new ListingVM(groups_data, coursework_listing), node, Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);
  }
};